import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
  useNodes,
  useStore,
} from "reactflow";

export default function GraphEdge({
  id,
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerStart,
  markerEnd,
}: EdgeProps) {
  // const showContent = useStore((s) => s.transform[2]);
  // const nodes = useNodes();

  // const targetNodes = nodes.filter((node) => node.id == source || node.id == target);

  // const BREAK_1 = showContent < 0.3;
  // const BREAK_2 = showContent > 0.3 && showContent < 0.5;
  // const BREAK_3 = showContent > 0.5 && showContent < 0.8;

  // if (BREAK_1 && targetNodes.some((node) => node.data?.depth > 1)) return <></>;
  // if (BREAK_2 && targetNodes.some((node) => node.data?.depth > 2)) return <></>;
  // if (BREAK_3 && targetNodes.some((node) => node.data?.depth > 3)) return <></>;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        key={`${id}-${markerStart}-${markerEnd}`}
        path={edgePath}
        markerStart={markerStart}
        markerEnd={markerEnd}
        style={style}
      />
    </>
  );
}
